module.exports = __webpack_public_path__ + "img/official-2.56a2a586.png";